import React from "react";
import { Bar } from 'react-chartjs-2';
import 'chart.piecelabel.js';
import 'chartjs-plugin-datalabels';

function GetSimpleBarGraph({ totalAllocated, updatedData }) {
  const updatedTotalAllocated = {
    labels: updatedData.months,
    datasets: [{
      label: totalAllocated.datasets[0].label,
      data: updatedData.monthWiseIOTCount,
      backgroundColor: totalAllocated.datasets[0].backgroundColor,
      hoverBackgroundColor: totalAllocated.datasets[0].hoverBackgroundColor
    }],
    text: totalAllocated.text,
    height: totalAllocated.height,
    monthWiseIOTData: totalAllocated.monthWiseIOTData,
  };

  const updatedTotalAllocatedProduction = {
    labels: updatedData.months,
    datasets: [{
      label: totalAllocated.datasets[0].label,
      data: updatedData.monthWiseIOTCount,
      backgroundColor: totalAllocated.datasets[0].backgroundColor,
      hoverBackgroundColor: totalAllocated.datasets[0].hoverBackgroundColor
    }],
    text: totalAllocated.text,
    height: totalAllocated.height,
    monthWiseData: totalAllocated.monthWiseIOTData,
  };

  const updatedTotalAllocatedDispatch = {
    labels: updatedData.months,
    datasets: [{
      label: totalAllocated.datasets[0].label,
      data: updatedData.monthWiseIOTCount,
      backgroundColor: totalAllocated.datasets[0].backgroundColor,
      hoverBackgroundColor: totalAllocated.datasets[0].hoverBackgroundColor
    }],
    text: totalAllocated.text,
    height: totalAllocated.height,
    dispatchMonthWiseData: totalAllocated.dispatchMonthWiseData,
  };

  const updatedTotalAllocatedReceive = {
    labels: totalAllocated.labels,
    datasets: [{
      label: totalAllocated.datasets[0].label,
      data: [updatedData[0], updatedData[1], updatedData[2], updatedData[3], updatedData[4], updatedData[5], updatedData[6], updatedData[7], updatedData[8], updatedData[9], updatedData[10], updatedData[11]],
      backgroundColor: totalAllocated.datasets[0].backgroundColor,
      hoverBackgroundColor: totalAllocated.datasets[0].hoverBackgroundColor
    }],
    text: totalAllocated.text,
    height: totalAllocated.height,
    receiveMonthWiseData: totalAllocated.receiveMonthWiseData,
  };

  const updatedTotalAllocatedLiveVsNonLive = {
    labels: totalAllocated.labels,
    datasets: [{
      label: totalAllocated.datasets[0].label,
      data: [updatedData.allProducts, updatedData.liveProducts, updatedData.nonLiveProducts],
      backgroundColor: totalAllocated.datasets[0].backgroundColor,
      hoverBackgroundColor: totalAllocated.datasets[0].hoverBackgroundColor
    }],
    text: totalAllocated.text,
    height: totalAllocated.height,
    liveVsNonLive: totalAllocated.liveVsNonLive,
  };

  const updatedTotalAllocatedTopProducts = {
    labels: updatedData.productName,
    datasets: [{
      label: totalAllocated.datasets[0].label,
      data: updatedData.productQuantity,
      backgroundColor: totalAllocated.datasets[0].backgroundColor,
      hoverBackgroundColor: totalAllocated.datasets[0].hoverBackgroundColor
    }],
    text: totalAllocated.text,
    height: totalAllocated.height,
    topProducts: totalAllocated.topProducts,
  };

  const updatedTotalAllocatedStackedGraph = {
    labels: updatedData.data1,
    datasets: [
      {
        label: totalAllocated.datasets[0].label1,
        data: updatedData.data4,
        backgroundColor: totalAllocated.datasets[0].backgroundColor1
      },
      {
        label: totalAllocated.datasets[0].label2,
        data: updatedData.data5,
        backgroundColor: totalAllocated.datasets[0].backgroundColor2
      }],
    text: totalAllocated.text,
    height: totalAllocated.height,
    stacked: totalAllocated.stacked,
    type: totalAllocated.type,
  };

  const options = {
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      position: 'bottom'
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    },
    plugins: {
      datalabels: {
        display: true,
        color: 'white',
        font: {
          weight: 'bold',
          size: 10
        }
      }
    }
  }

  const optionsForMonthlyDispatch = {
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      position: 'bottom'
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    },
    plugins: {
      datalabels: {
        display: false,
        color: 'black',
        font: {
          weight: 'bold',
        }
      }
    }
  }

  const optionsForMonthlyReceive = {
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      position: 'bottom'
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    },
    plugins: {
      datalabels: {
        display: false,
        color: 'black',
        font: {
          weight: 'bold',
        }
      }
    }
  }

  const optionsForMonthWiseIOTData = {
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      position: 'bottom'
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    },
    plugins: {
      datalabels: {
        display: false,
        color: 'black',
        font: {
          weight: 'bold',
        }
      }
    }
  }

  const optionsForMonthWiseData = {
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      position: 'bottom'
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    },
    plugins: {
      datalabels: {
        display: false,
        color: 'black',
        font: {
          weight: 'bold',
        }
      }
    }
  }

  const optionsForStackedGraph = {
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      position: 'bottom'
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    scales: {
      xAxes: [{
        stacked: true
      }],
      yAxes: [{
        stacked: true,
        ticks: {
          min: 0,
          max: 100,
          callback: function (value) { return value + "%" }
        },
        scaleLabel: {
          display: true,
          labelString: "Percentage"
        }
      }]
    },
    plugins: {
      datalabels: {
        display: false,
        color: 'black',
        font: {
          weight: 'bold',
        }
      }
    }
  }

  if (totalAllocated.stacked) {
    return (
      <>
        <Bar data={updatedTotalAllocatedStackedGraph} options={optionsForStackedGraph} />
      </>
    )
  }
  else if (totalAllocated.monthWiseData) {
    return (
      <>
        <Bar data={updatedTotalAllocatedProduction} options={optionsForMonthWiseData} />
      </>
    )
  }
  else if (totalAllocated.dispatchMonthWiseData) {
    return (
      <>
        <Bar data={updatedTotalAllocatedDispatch} options={optionsForMonthlyDispatch} />
      </>
    )
  }
  else if (totalAllocated.receiveMonthWiseData) {
    return (
      <>
        <Bar data={updatedTotalAllocatedReceive} options={optionsForMonthlyReceive} />
      </>
    )
  }
  else if (totalAllocated.monthWiseIOTData) {
    return (
      <>
        <Bar data={updatedTotalAllocated} options={optionsForMonthWiseIOTData} />
      </>
    )
  }
  else if (totalAllocated.liveVsNonLive) {
    return (
      <>
        <Bar data={updatedTotalAllocatedLiveVsNonLive} options={options} />
      </>
    )
  }
  else if (totalAllocated.topProducts) {
      return (
        <>
          <Bar data={updatedTotalAllocatedTopProducts} options={options} />          
        </>
      )
  }
  else {
    return (
      <>
        <Bar data={totalAllocated} options={options} />
      </>
    );
  }
}

const SimpleBarGraph = (props) => {
  return <GetSimpleBarGraph updatedData={props.updatedData} totalAllocated={props.totalAllocated} />;
}

export default SimpleBarGraph;